var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillsAndDiscountsLtr = function SvgBillsAndDiscountsLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M69.19 34.88 34.815 69.257l-3.27-3.27L65.92 31.61z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M50.342 5 61.48 15.799l14.378-2.006 3.713 14.852 13.079 8.049-5.734 13.492 5.35 14.715-12.658 7.329-3.033 14.489-14.757-1.677-11.137 10.8L39.562 85.06l-15.138 2.018-2.697-14.837-13.358-7.347 6.029-14.403L8 37.022l14.051-8.363L25.1 13.417l14.47 2.356zm.05 6.49-9.227 9.228-12.405-2.02-2.577 12.884-12.198 7.26 5.477 11.531-5.221 12.473 11.642 6.403 2.303 12.663 12.987-1.732 9.507 9.22 9.487-9.2 12.743 1.447 2.593-12.386 11.091-6.421-4.649-12.786 4.89-11.507-11.295-6.951-3.162-12.648-12.497 1.744z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39.43 36.496a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-7.625 3a7.625 7.625 0 1 1 15.25 0 7.625 7.625 0 0 1-15.25 0M61.304 58.37a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-7.625 3a7.625 7.625 0 1 1 15.25 0 7.625 7.625 0 0 1-15.25 0",
    clipRule: "evenodd"
  })));
};
export default SvgBillsAndDiscountsLtr;